export const SERVICES_CONSTS = {
    SET_SERVICES_DATA:"SET_SERVICES_DATA",
};
